import React from 'react';

const ExtraDownloadContainer = () => {
  return <></>;
};

export default ExtraDownloadContainer;
